var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FAFAFA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.91 5L6 12.5 13.91 20 15 18.877 8.275 12.5 15 6.122z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowWhite);
export default __webpack_public_path__ + "static/media/ic_arrow_white.4b072f1b0dfb49addec17f905b51dba3.svg";
export { ForwardRef as ReactComponent };